module.exports = __webpack_public_path__ + "static/media/mail.47744948.svg";